var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardimage2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 70.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8393 98.0178H32.6012C30.6369 98.0178 29 96.3809 29 94.4166V51.857C29 49.8928 30.6369 48.2559 32.6012 48.2559H36.3661C37.0208 48.2559 37.5119 48.7469 37.5119 49.4017V52.5118H39.8036V49.4017C39.8036 48.7469 40.2946 48.2559 40.9494 48.2559H61.7381C62.3929 48.2559 62.8839 48.7469 62.8839 49.4017V52.5118H65.1756V49.4017C65.1756 48.7469 65.6667 48.2559 66.3214 48.2559H87.1101C87.7649 48.2559 88.256 48.7469 88.256 49.4017V52.5118H90.5476V49.4017C90.5476 48.7469 91.0387 48.2559 91.6935 48.2559H95.4583C97.4226 48.2559 99.0595 49.8928 99.0595 51.857V70.3541C99.0595 71.0088 98.5685 71.4999 97.9137 71.4999C90.875 71.4999 85.3095 77.2291 85.3095 84.1041C85.3095 89.1785 88.4196 93.9255 93.1667 95.7261C93.8214 96.0535 93.9851 96.5446 93.9851 97.0356C93.8214 97.6904 93.3304 98.0178 92.8393 98.0178Z",
    fill: "#EEF6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8392 98.0177H89.0743C88.0922 97.363 87.11 96.5445 86.2916 95.7261C83.1815 92.6159 81.3809 88.5237 81.3809 84.104C81.3809 79.6844 83.1815 75.5921 86.2916 72.482C89.4017 69.3719 93.494 67.5713 97.9136 67.5713C98.241 67.5713 98.732 67.5713 99.0594 67.5713V70.354C99.0594 71.0088 98.5684 71.4999 97.9136 71.4999C90.8749 71.4999 85.3094 77.229 85.3094 84.104C85.3094 89.1784 88.4195 93.9255 93.1666 95.7261C93.8213 96.0534 93.985 96.5445 93.985 97.0356C93.8213 97.6903 93.3303 98.0177 92.8392 98.0177Z",
    fill: "#DAE1E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9139 99.0002C93.9853 99.0002 90.2204 97.3633 87.4377 94.5805C84.4913 91.7978 83.0181 88.0329 83.0181 84.1043C83.0181 80.1758 84.4913 76.4109 87.4377 73.6281C90.2204 70.8454 93.9853 69.2085 97.9139 69.2085C101.842 69.2085 105.607 70.6817 108.39 73.6281C111.173 76.4109 112.81 80.1758 112.81 84.1043C112.81 88.0329 111.337 91.7978 108.39 94.5805C105.607 97.3633 101.842 99.0002 97.9139 99.0002Z",
    fill: "#FCBE37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4761 90.6518C94.1487 90.6518 93.8213 90.4881 93.6576 90.3244L89.8927 86.3958C89.4016 85.9048 89.4016 85.25 89.8927 84.7589C90.3838 84.2679 91.0386 84.2679 91.5296 84.7589L94.4761 87.869L104.461 77.8839C104.952 77.3929 105.607 77.3929 106.098 77.8839C106.589 78.375 106.589 79.0298 106.098 79.5208L95.2945 90.3244C95.1308 90.4881 94.8034 90.6518 94.4761 90.6518Z",
    fill: "#EEF6FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7857 54.8036H36.366C35.7113 54.8036 35.2202 54.3125 35.2202 53.6577V45.1458C35.2202 44.4911 35.7113 44 36.366 44H40.7857C41.4405 44 42.0952 44.4911 42.0952 45.1458V53.6577C42.0952 54.3125 41.4405 54.8036 40.7857 54.8036Z",
    fill: "#DFDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1578 54.8036H61.7381C61.0834 54.8036 60.5923 54.3125 60.5923 53.6577V45.1458C60.5923 44.4911 61.0834 44 61.7381 44H66.1578C66.8125 44 67.4673 44.4911 67.4673 45.1458V53.6577C67.4673 54.3125 66.8125 54.8036 66.1578 54.8036Z",
    fill: "#DFDDDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.5298 54.8036H87.1102C86.4554 54.8036 85.9644 54.3125 85.9644 53.6577V45.1458C85.9644 44.4911 86.4554 44 87.1102 44H91.5298C92.1846 44 92.6757 44.4911 92.6757 45.1458V53.6577C92.6757 54.3125 92.1846 54.8036 91.5298 54.8036Z",
    fill: "#DFDDDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9316 69.5357H35.384C34.4018 69.5357 33.7471 68.881 33.7471 67.8988V63.4792C33.7471 62.497 34.4018 61.8423 35.384 61.8423H41.9316C42.9137 61.8423 43.5685 62.497 43.5685 63.4792V67.8988C43.5685 68.881 42.9137 69.5357 41.9316 69.5357Z",
    fill: "#91E0E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5356 69.5357H47.988C47.0058 69.5357 46.3511 68.881 46.3511 67.8988V63.4792C46.3511 62.497 47.0058 61.8423 47.988 61.8423H54.5356C55.5177 61.8423 56.1725 62.497 56.1725 63.4792V67.8988C56.1725 68.881 55.5177 69.5357 54.5356 69.5357Z",
    fill: "#91E0E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1401 69.5357H60.5925C59.6103 69.5357 58.9556 68.881 58.9556 67.8988V63.4792C58.9556 62.497 59.6103 61.8423 60.5925 61.8423H67.1401C67.9585 61.8423 68.777 62.497 68.777 63.4792V67.8988C68.777 68.881 67.9585 69.5357 67.1401 69.5357Z",
    fill: "#91E0E8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7441 69.5357H73.1965C72.2143 69.5357 71.5596 68.881 71.5596 67.8988V63.4792C71.5596 62.497 72.2143 61.8423 73.1965 61.8423H79.7441C80.5625 61.8423 81.381 62.497 81.381 63.4792V67.8988C81.381 68.881 80.5625 69.5357 79.7441 69.5357Z",
    fill: "#91E0E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9316 81.8126H35.384C34.4018 81.8126 33.7471 81.1578 33.7471 80.1757V75.756C33.7471 74.7739 34.4018 74.1191 35.384 74.1191H41.9316C42.9137 74.1191 43.5685 74.7739 43.5685 75.756V80.1757C43.5685 81.1578 42.9137 81.8126 41.9316 81.8126Z",
    fill: "#91E0E8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5356 81.8126H47.988C47.0058 81.8126 46.3511 81.1578 46.3511 80.1757V75.756C46.3511 74.7739 47.0058 74.1191 47.988 74.1191H54.5356C55.5177 74.1191 56.1725 74.7739 56.1725 75.756V80.1757C56.1725 81.1578 55.5177 81.8126 54.5356 81.8126Z",
    fill: "#91E0E8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1401 81.8126H60.5925C59.6103 81.8126 58.9556 81.1578 58.9556 80.1757V75.756C58.9556 74.7739 59.6103 74.1191 60.5925 74.1191H67.1401C67.9585 74.1191 68.777 74.7739 68.777 75.756V80.1757C68.777 81.1578 67.9585 81.8126 67.1401 81.8126Z",
    fill: "#91E0E8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7441 81.8126H73.1965C72.2143 81.8126 71.5596 81.1578 71.5596 80.1757V75.756C71.5596 74.7739 72.2143 74.1191 73.1965 74.1191H79.7441C80.5625 74.1191 81.381 74.7739 81.381 75.756V80.1757C81.381 81.1578 80.5625 81.8126 79.7441 81.8126Z",
    fill: "#91E0E8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9316 94.0894H35.384C34.4018 94.0894 33.7471 93.4347 33.7471 92.4525V88.0329C33.7471 87.0508 34.4018 86.396 35.384 86.396H41.9316C42.9137 86.396 43.5685 87.0508 43.5685 88.0329V92.4525C43.5685 93.4347 42.9137 94.0894 41.9316 94.0894Z",
    fill: "#91E0E8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5356 94.0894H47.988C47.0058 94.0894 46.3511 93.4347 46.3511 92.4525V88.0329C46.3511 87.0508 47.0058 86.396 47.988 86.396H54.5356C55.5177 86.396 56.1725 87.0508 56.1725 88.0329V92.4525C56.1725 93.4347 55.5177 94.0894 54.5356 94.0894Z",
    fill: "#91E0E8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1401 94.0894H60.5925C59.6103 94.0894 58.9556 93.4347 58.9556 92.4525V88.0329C58.9556 87.0508 59.6103 86.396 60.5925 86.396H67.1401C67.9585 86.396 68.777 87.0508 68.777 88.0329V92.4525C68.777 93.4347 67.9585 94.0894 67.1401 94.0894Z",
    fill: "#91E0E8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7441 94.0894H73.1965C72.2143 94.0894 71.5596 93.4347 71.5596 92.4525V88.0329C71.5596 87.0508 72.2143 86.396 73.1965 86.396H79.7441C80.5625 86.396 81.381 87.0508 81.381 88.0329V92.4525C81.381 93.4347 80.5625 94.0894 79.7441 94.0894Z",
    fill: "#91E0E8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5923 53.6576V48.2559H42.0952V53.6576C42.0952 54.3124 41.4405 54.8035 40.7857 54.8035H36.3661C35.7113 54.8035 35.2202 54.3124 35.2202 53.6576V48.2559H32.6012C30.6369 48.2559 29 49.8928 29 51.857V57.9136V60.2053H99.0595V57.9136V51.857C99.0595 49.8928 97.4226 48.2559 95.4583 48.2559H92.6756V53.6576C92.6756 54.3124 92.1845 54.8035 91.5298 54.8035H87.1101C86.4554 54.8035 85.9643 54.3124 85.9643 53.6576V48.2559H67.4673V53.6576C67.4673 54.3124 66.8125 54.8035 66.1577 54.8035H61.7381C61.0833 54.8035 60.5923 54.3124 60.5923 53.6576Z",
    fill: "#DF5A49"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardimage2);
export default __webpack_public_path__ + "static/media/cardimage2.0db8702c42585442f7085e6a409ab080.svg";
export { ForwardRef as ReactComponent };